'use client';
import { useEffect, useRef, useState } from 'react';
import MenuArrows from './svg/MenuArrows';
import DropdownMenu from './DropdownMenu';
import { twMerge } from 'tailwind-merge';

interface MenuSelectProps {
  selected?: string | number;
  placeholder?: string;
  onChange: (value: string | number) => void;
  options: {
    title: string;
    value: string | number;
  }[];
  dir?: 'ltr' | 'rtl';
  className?: Partial<{
    wrapper: string;
    menu: Partial<{
      wrapper: string;
      item: string;
    }>;
  }>;
}

export function MenuSelect({ selected, placeholder, onChange, className, options, dir = 'rtl' }: MenuSelectProps) {

  const [expanded, setExpanded] = useState(false);


  const menuRef = useRef<any>();
  const containerRef = useRef<any>();

  const handleClick = (e: MouseEvent) => {
    const { current: menu } = menuRef;
    const { current: container } = containerRef;
    if (
      (container?.contains(e.target) || container?.contains(menu)) &&
      (menu ? !menu.contains(e.target) : true)
    ) setExpanded(prevState => !prevState);
  }

  useEffect(() => {
    window.addEventListener('mousedown', handleClick);
    return () => {
      window.removeEventListener('mousedown', handleClick);
    }
  }, []);


  const handleChange = (value: string | number) => {
    onChange(value);
    setExpanded(false);
  }

  return (
    <div ref={containerRef} dir={dir} className={twMerge(className?.wrapper)}>
      <div className='flex items-center gap-[inherit] overflow-hidden w-full justify-between [&>*]:flex-shrink-0'>

      <span className={twMerge('w-[80%] overflow-hidden sm')}>{options.find(({ value }) => selected === value)?.title || placeholder || ''}</span>
      <MenuArrows className='w-[13px] h-[19px] dark:[&>path]:fill-white flex-shrink-0' />
      </div>
      {expanded ? <DropdownMenu ref={menuRef} key={String(expanded)} selected={selected} onChange={handleChange} options={options} className={className?.menu} /> : null}
    </div>
  )
}